export function getInitialsFromName(name: string): string {
    const [firstName, lastName] = name.split(" ") ?? '';
    return [firstName, lastName]
        .filter((datum) => datum)
        .map((datum) => {
            return datum.charAt(0);
        })
        .join("");
}

export function splitFullName(name: string) {
    const [first, last] = name.split(' ');
    return [first, last];
}

export function joinFullName(first: string, last: string) {
    return `${first} ${last}`;
}